"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudentStatusControls = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const common_1 = require("../../../../common");
const StudentStatusControlsStyled = styled_components_1.default.div `
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: ${({ $isMobile }) => ($isMobile ? 'flex-start' : 'flex-end')};
	gap: 16px;
	flex-wrap: wrap;
	padding: ${({ $isMobile }) => ($isMobile ? '16px 14px' : '0')};
	background-color: ${({ $isMobile }) => ($isMobile ? '#f3f5f8' : 'transparent')};
	margin-top: ${({ $isMobile }) => ($isMobile ? '20px' : '0')};

	.controls-meta {
		color: #8f9298;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: ${({ $isMobile }) => ($isMobile ? '12px' : '14px')};
		line-height: 150%;
	}

	.controls-right {
		display: flex;
		align-items: center;
		gap: 12px;
		flex-wrap: wrap;
		${({ $isMobile }) => $isMobile &&
    `
			width: 100%;
		`}
	}

	/* 조회 기간(시작일~종료일) 입력 — 주차 드롭박스 대체 */
	.period-field {
		display: flex;
		align-items: center;
		gap: 8px;
		${({ $isMobile }) => $isMobile && 'flex: 1 1 100%;'}
	}

	.period-field input[type='date'] {
		padding: 10px 12px;
		border: 1px solid #b6bac0;
		border-radius: 8px;
		background: #fff;
		color: #101010;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 14px;
		line-height: 150%;
		-webkit-appearance: none;
		appearance: none;
		${({ $isMobile }) => $isMobile && 'flex: 1; min-width: 0;'}
	}

	.download-btn {
		padding: 12px 24px;
	}
`;
exports.StudentStatusControls = react_1.default.memo(({ isMobile, isTablet, generatedAt, periodStartDate, periodEndDate, onChangePeriodStart, onChangePeriodEnd, onPrint, showControlsRight = true, }) => {
    return (react_1.default.createElement(StudentStatusControlsStyled, { "$isMobile": isMobile, "$isTablet": isTablet },
        react_1.default.createElement("div", { className: "controls-meta" }, `기준일시 ${generatedAt}`),
        showControlsRight && (react_1.default.createElement("div", { className: "controls-right" },
            react_1.default.createElement("div", { className: "period-field" },
                react_1.default.createElement("input", { type: "date", value: periodStartDate, onChange: e => onChangePeriodStart(e.target.value), min: "2000-01-01", max: "2100-12-31" }),
                react_1.default.createElement(common_1.Icon, { icon: "dash", width: 12 }),
                react_1.default.createElement("input", { type: "date", value: periodEndDate, onChange: e => onChangePeriodEnd(e.target.value), min: "2000-01-01", max: "2100-12-31" })),
            react_1.default.createElement(common_1.Button, { className: "btn_default xmd download-btn", text: "common.print", onClick: onPrint })))));
});
